import { CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { PaletteColor } from '@utils/types';

import { CloseButtonContainer } from './styled';

interface ModalCloseButtonProps {
  onClick?: () => void;
  noLabel?: boolean;
  paletteColor?: PaletteColor;
}
export const ModalCloseButton = ({
  paletteColor = 'darkGray',
  ...rest
}: ModalCloseButtonProps) => (
  <CloseButtonContainer {...rest}>
    <CustomIcon
      icon={CloseIcon}
      fontSize={24}
      paletteColor={paletteColor}
      data-testid='close-button'
    />
  </CloseButtonContainer>
);
